module.exports = __webpack_public_path__ + "img/pay.af4850ad.svg";